import { Tick, TimeClock } from '@berlitz/icons'
import Circle from '@berlitz/streamline-icons/lib/bold/48-Maps-Navigation/04-Sign-Shapes/SignBadgeCircleAlternate'
import { StyledIcon } from '@layouts/LearningPath/Chapter/style'
import { LP_STATUS } from '@utils/constants/learningPath'
import React from 'react'

const ExtraPracticeIcon: React.FC<{ status: string }> = ({ status }) => {
  switch (status) {
    case LP_STATUS.COMPLETE:
      return (
        <StyledIcon status="complete">
          <Tick />
        </StyledIcon>
      )
    case LP_STATUS.IN_PROGRESS:
      return (
        <StyledIcon status="inprogress">
          <TimeClock />
        </StyledIcon>
      )
    default:
      return (
        <StyledIcon>
          <Circle color="brand01" />
        </StyledIcon>
      )
  }
}

export default ExtraPracticeIcon
